import { render, staticRenderFns } from "./ProRank2.vue?vue&type=template&id=02de84fc&scoped=true&"
import script from "./ProRank2.vue?vue&type=script&lang=js&"
export * from "./ProRank2.vue?vue&type=script&lang=js&"
import style0 from "./ProRank2.vue?vue&type=style&index=0&id=02de84fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de84fc",
  null
  
)

export default component.exports